import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9742f80c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row items-center justify-between" }
const _hoisted_2 = { "data-testid": "my-works" }
const _hoisted_3 = {
  key: 0,
  class: "works-count text-body-light"
}
const _hoisted_4 = { class: "not-pointed" }
const _hoisted_5 = { class: "pointed" }
const _hoisted_6 = {
  key: 1,
  class: "h2 text-center text-darkening-grey"
}
const _hoisted_7 = {
  key: 2,
  class: "works-table table table-stack-medium",
  "data-testid": "works-table"
}
const _hoisted_8 = {
  class: "thead",
  "data-testid": "works-table-header"
}
const _hoisted_9 = { class: "tr row small-gutter" }
const _hoisted_10 = { class: "th col-4-medium" }
const _hoisted_11 = { class: "th col-1-medium" }
const _hoisted_12 = { class: "th col-2-medium" }
const _hoisted_13 = { class: "th col-2-medium" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "th col-3-medium" }, null, -1))
const _hoisted_15 = { class: "tbody" }

import { useRouter } from 'vue-router'
import IconUI from '@/components/CommonUI/IconUI.vue'
import WorkItem from '@/components/MyWorks/WorkItem.vue'
import WorksFilters from '@/components/MyWorks/WorksFilters.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useUserStore } from '@/store/user'
import { filtersNames, useWorksStore } from '@/store/works'
import { workFilters } from '@/constants'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import UpgradeDialog from '@/components/UpgradeDialog.vue'
import { getErrorMessage } from '@/helpers/errors'
import { useGettext } from 'vue3-gettext'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyWorks',
  setup(__props) {

const userStore = useUserStore()
const workStore = useWorksStore()
const router = useRouter()
const { $gettext } = useGettext()

const isLoading = ref(true)
const currentPage = ref(1)
const perPage = ref(10)
const selectedFilter = ref(filtersNames[0] as string)
const errorMessage = ref('')
const upgradeDialog = ref<InstanceType<typeof UpgradeDialog> | null>(null)

const hasProOrLabelSubscription = userStore.hasProOrLabelSubscription
const userId = userStore.user.id

const filterStatuses = computed(() => workFilters[selectedFilter.value])
const allFilteredWorksByStatuses = computed<Work[]>(
  () => (filterStatuses.value.length
    ? workStore.works.filter(work => work.status && filterStatuses.value.includes(work.status))
    : workStore.works),
)
const filteredWorksPerPage = computed<Work[]>(
  () => allFilteredWorksByStatuses.value
    .slice((currentPage.value * perPage.value) - perPage.value, currentPage.value * perPage.value),
)

async function getWorks() {
  try {
    isLoading.value = true

    await Promise.all([
      workStore.getUserWorksByStatuses([], false),
      userStore.getLinkedAccounts(),
      userId && !userStore.userDetails && userStore.getUserDetails(userId),
    ])

    isLoading.value = false
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
}

onMounted(async () => {
  await getWorks()
})

function changeFilter(filter: string) {
  selectedFilter.value = filter
  currentPage.value = 1
}

function changePage(page: number) {
  currentPage.value = page
}

function addWork() {
  if (hasProOrLabelSubscription) {
    router.push('/works/create')

    return
  }

  upgradeDialog.value?.show()
}

watch(
  () => filteredWorksPerPage.value.length,
  length => {
    if (!length && currentPage.value > 1) changePage(currentPage.value - 1)
  },
)

return (_ctx: any,_cache: any) => {
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UpgradeDialog, {
      ref_key: "upgradeDialog",
      ref: upgradeDialog,
      dismissible: ""
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref($gettext)('My Works')) + " ", 1),
        (_unref(workStore).worksCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_unref(workStore).worksCount) + ")", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "secondary add-work-button",
        type: "button",
        onClick: addWork
      }, [
        _createVNode(IconUI, { name: "plus" }),
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createTextVNode("Add Work")
        ])), [
          [_directive_translate]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, [
          _createTextVNode("Add a new work")
        ])), [
          [_directive_translate]
        ])
      ])
    ]),
    _createVNode(WorksFilters, {
      "data-testid": "works-filters",
      filters: _unref(filtersNames),
      selected: selectedFilter.value,
      disabled: isLoading.value || !_unref(workStore).worksCount,
      onFilterChanged: changeFilter
    }, null, 8, ["filters", "selected", "disabled"]),
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoaderErrorBlock, {
          key: 0,
          "error-message": errorMessage.value,
          class: "row no-space justify-center"
        }, null, 8, ["error-message"]))
      : (!_unref(workStore).works.length)
        ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(" No works registered. ")
          ])), [
            [_directive_translate]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createTextVNode(" Title ")
                ])), [
                  [_directive_translate]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createTextVNode(" Writers ")
                ])), [
                  [_directive_translate]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createTextVNode(" Duration ")
                ])), [
                  [_directive_translate]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createTextVNode(" Status ")
                ])), [
                  [_directive_translate]
                ]),
                _hoisted_14
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredWorksPerPage.value, (work) => {
                return (_openBlock(), _createBlock(WorkItem, {
                  key: work.id,
                  work: work
                }, null, 8, ["work"]))
              }), 128))
            ])
          ])),
    (allFilteredWorksByStatuses.value.length && allFilteredWorksByStatuses.value.length > perPage.value && !isLoading.value)
      ? (_openBlock(), _createBlock(_component_vue_awesome_paginate, {
          key: 3,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          "total-items": allFilteredWorksByStatuses.value.length,
          "items-per-page": perPage.value,
          "max-pages-shown": 4,
          "on-click": changePage,
          "disable-pagination": isLoading.value,
          "hide-prev-next": "",
          "data-testid": "works-pagination"
        }, null, 8, ["modelValue", "total-items", "items-per-page", "disable-pagination"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})